// app/javascript/controllers/modal_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"];

  connect() {
    this.dialog = this.element;
  }

  disconnect() {
    this.dialog.close();
  }

  open() {
    this.dialog.showModal();
  }

  close(event) {
    let form = this.dialog.querySelector("#modal-inner-form");
    if (form && form.dataset) {
      if (form.dataset.modalCloseOnSubmit === "false") {
        return;
      }
    }

    this.dialog.close();
  }
}
